import { LineProgressBar, Typography } from 'mobily-ui-library/lib';

import BackArrow from '../../assets/BackArrow.svg';
import { useTranslation } from 'react-i18next';
import './HeaderNavigation.scss';
import { useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';

interface Props {
    rtl: boolean;
    showBackArrow: boolean;
    handleBackArrow: () => void;
    percent: number;
}

function HeaderNavigation({ rtl, showBackArrow = false, handleBackArrow, percent }: Props) {
    const { t } = useTranslation();
    const { state }: any = useContext(GlobalContext);
    const { requestFlow } = state;
    return (
        <div className='Ftth__headerNav'>
            <img
                src={BackArrow}
                alt='back-arrow'
                className='DSHN__backArrow'
                onClick={handleBackArrow}
                style={{ visibility: showBackArrow ? "visible" : "hidden" }}
            />
            <div className='Ftth__headerGroup'>
                <Typography rtl={rtl}>{requestFlow === 'installation' ? t('Request_new_fiber_optic') : t("Register_interest_fiber_expansion")}</Typography>
                <LineProgressBar rtl={rtl} percent={percent} />
            </div>
            <a href="/wps/portal/web/personal/am-overview/contact-us">
                <Typography rtl={rtl} color='#008CFF' fontFamily='SimplonNorm-Bold, ExpoArabic-Bold'>{t("HELP")}</Typography>
            </a>
        </div>
    )
}

export default HeaderNavigation